import { Box, Popover, Typography } from '@atgfr8/atg-ui-tailwind';
import { uniqueId } from 'lodash';
import { createSignal, JSXElement } from 'solid-js';

type PropsT = {
  children: JSXElement;
  id?: string;
  message: string;
};

export const MouseOverPopover = (props: PropsT) => {
  const [anchorEl, setAnchorEl] = createSignal<Element | null>(null);

  const handlePopoverOpen = (event: { currentTarget: Element }) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = () => Boolean(anchorEl());

  const id = props.id ?? `mouseover-popover-${uniqueId()}`;

  return (
    <div>
      <Box
        aria-owns={open() ? id : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {props.children}
      </Box>
      <Popover
        id={id}
        sx={{ 'pointer-events': 'none' }}
        open={open()}
        anchorEl={anchorEl()}
        dataTestId={id}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sxProps={{ padding: '8px' }}>{props.message}</Typography>
      </Popover>
    </div>
  );
};
